import apiClient from './client';
import { Propinsi } from '@/types';

export interface PropinsiListParams {
  page?: number;
  limit?: number;
  search?: string;
}

export interface PropinsiListResponse {
  data: Propinsi[];
  total: number;
  page: number;
  limit: number;
}

export interface MessageResponse {
  message: string;
}

export const propinsiApi = {
  getAll: async (params: PropinsiListParams = {}): Promise<PropinsiListResponse> => {
    const response = await apiClient.get('/api/propinsi', { params });
    return response.data;
  },

  getOptions: async (): Promise<{ data: Propinsi[] }> => {
    const response = await apiClient.get('/api/propinsi/options');
    return response.data;
  },

  create: async (data: Partial<Propinsi>): Promise<MessageResponse> => {
    const response = await apiClient.post('/api/propinsi', data);
    return response.data;
  },

  update: async (id: number, data: Partial<Propinsi>): Promise<MessageResponse> => {
    const response = await apiClient.put(`/api/propinsi/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<MessageResponse> => {
    const response = await apiClient.delete(`/api/propinsi/${id}`);
    return response.data;
  },
};
